import "./Events.css";
import Container from "react-bootstrap/Container";
import { Row, Col, Button, Spinner } from "react-bootstrap";

import axios from "../../network/api";
import { useState, useEffect } from "react";
import { baseUrl } from "../../network/Constants";
import viewMoreIcon from "../../assets/right-arrow.svg";

function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [moreEvents, setMoreEvents] =  useState(6)

  const ViewMoreEvents = () => {
    setMoreEvents((prevValue) => prevValue + prevValue)
  }

  useEffect(() => {
    fetchEvent();
  }, []);

  const fetchEvent = (props) => {
    setLoading(true);
    axios
      .get(baseUrl + "/app/events/")
      .then(async (response) => {
        console.log(response.data);
        setEvents(response.data);
        setLoading(false);
        console.log("huyyaEvents: " + JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  return (
    <section className="events" id="events">
      <Container>
        <div className="section-title">Upcoming Events</div>
        {loading ? (
          <div className="loader">
            <Spinner className="loading-color" />
          </div>
        ) : (
          <Row>
            
              {events.slice(0, moreEvents).map((item, index) => {
                return (
                  <Col lg={4} key={index}>
                    <div className="p-0  py-4">
                      <img
                        className="img-fluid event-img"
                        src={item.event_image}
                      ></img>
                    </div>
                    <div className="view-more ">
                      {item.link && (
                        <a href={item.link} target="_blank">
                          <Button className="view-more-btn">
                            Registration <img src={viewMoreIcon}></img>
                          </Button>
                        </a>
                      )}
                    </div>
                  </Col>
                );
              })}
              
            
          </Row>
        )}

        {events.length > 6 && (
          <div className="view-more">
            <Button href="/viewmoreevent" className="view-more-btn">
              View more
              <img src={viewMoreIcon} onClick={ViewMoreEvents} />
            </Button>
          </div>
        )}
      </Container>
    </section>
  );
}

export default Events;
